import Icon from '../../../components/AppIcon';

const AnalyticsChart = ({ data }) => {
  // Find max value for scaling
  const maxUsers = Math.max(...data?.map(d => d?.users || 0));
  const maxJobs = Math.max(...data?.map(d => d?.jobs || 0));
  const maxRevenue = Math.max(...data?.map(d => d?.revenue || 0));

  return (
    <div className="bg-card rounded-lg shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="BarChart3" size={24} />
          Platform Analytics
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Track platform growth, user activity, and revenue trends over the last 7 days
        </p>
      </div>

      <div className="p-6">
        {/* Legend */}
        <div className="flex flex-wrap items-center gap-6 mb-6">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-primary"></div>
            <span className="text-sm text-muted-foreground">New Users</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-accent"></div>
            <span className="text-sm text-muted-foreground">Job Postings</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-success"></div>
            <span className="text-sm text-muted-foreground">Revenue (PHP)</span>
          </div>
        </div>

        {/* Chart */}
        <div className="space-y-6">
          {data?.map((day, index) => (
            <div key={index} className="space-y-2">
              <p className="text-sm font-medium text-foreground">{day?.date}</p>
              
              {/* Users Bar */}
              <div className="flex items-center gap-3">
                <div className="w-20 text-xs text-muted-foreground">Users</div>
                <div className="flex-1 bg-muted/50 rounded-full h-6 overflow-hidden">
                  <div
                    className="bg-primary h-full rounded-full flex items-center justify-end pr-2 transition-all"
                    style={{ width: `${(day?.users / maxUsers) * 100}%` }}
                  >
                    <span className="text-xs font-medium text-white">{day?.users}</span>
                  </div>
                </div>
              </div>

              {/* Jobs Bar */}
              <div className="flex items-center gap-3">
                <div className="w-20 text-xs text-muted-foreground">Jobs</div>
                <div className="flex-1 bg-muted/50 rounded-full h-6 overflow-hidden">
                  <div
                    className="bg-accent h-full rounded-full flex items-center justify-end pr-2 transition-all"
                    style={{ width: `${(day?.jobs / maxJobs) * 100}%` }}
                  >
                    <span className="text-xs font-medium text-white">{day?.jobs}</span>
                  </div>
                </div>
              </div>

              {/* Revenue Bar */}
              <div className="flex items-center gap-3">
                <div className="w-20 text-xs text-muted-foreground">Revenue</div>
                <div className="flex-1 bg-muted/50 rounded-full h-6 overflow-hidden">
                  <div
                    className="bg-success h-full rounded-full flex items-center justify-end pr-2 transition-all"
                    style={{ width: `${(day?.revenue / maxRevenue) * 100}%` }}
                  >
                    <span className="text-xs font-medium text-white">₱{day?.revenue?.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8 pt-6 border-t border-border">
          <div className="text-center">
            <p className="text-2xl font-bold text-primary">
              {data?.reduce((sum, d) => sum + d?.users, 0)}
            </p>
            <p className="text-sm text-muted-foreground mt-1">Total New Users</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-accent">
              {data?.reduce((sum, d) => sum + d?.jobs, 0)}
            </p>
            <p className="text-sm text-muted-foreground mt-1">Total Job Postings</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-success">
              ₱{data?.reduce((sum, d) => sum + d?.revenue, 0)?.toLocaleString()}
            </p>
            <p className="text-sm text-muted-foreground mt-1">Total Revenue</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsChart;